export default {
  buttons: {
    login: 'Anmelden',
  },
  feedback: {
    incorrect_code: 'Der eingegebene Code ist ungültig. Bitte versuche es erneut.',
    expired_code: 'Dieser Code ist abgelaufen. Bitte fordere einen neuen an.',
    too_many_attempts: 'Zu viele Versuche. Bitte warte einen Moment und versuche es erneut.',
    unknown: 'Bei der Überprüfung deines Codes ist etwas schiefgelaufen. Bitte versuche es erneut.',
    network_error: 'Wir konnten den Server nicht erreichen. Prüfe deine Verbindung und versuche es erneut.',
  },
};
